/**
 * Banner Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface Banner {
  id?: number;
  banner_id?: number;
  banner_name: string;
  banner_image?: string;
  banner_url?: string;
  role_id?: number;
  role_name?: string;
  active?: number | boolean;
  start_date?: string;
  end_date?: string;
  created_at?: string;
  updated_at?: string;
  program_id?: number;
}

export interface BannerFormData {
  id?: number;
  banner_id?: number;
  banner_name: string;
  banner_image?: string | File;
  banner_url?: string;
  role_id?: number;
  active?: number | boolean;
  start_date?: string;
  end_date?: string;
}

export interface BannerApiResponse {
  data: {
    banners: Banner[];
  };
  message?: string;
  success?: boolean;
}
